import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query Filter5NoEntryIntoTheUsageUnitWithoutEquipmentQuery(
    $companyId: ID!
    $startRow: Int
    $endRow: Int
    $sortModel: [Sort]
    $filters: [Filter]
  ) {
    Me {
      Company(id: $companyId) {
        data: UsageUnits(
          options: {
            startRow: $startRow
            endRow: $endRow
            sorting: $sortModel
            filters: $filters
          }
          context: RecentRegularAppointment
        ) {
          id
          referenceNumber
          tableId
          address {
            city
            street
            number
          }
          tenants {
            id
            firstname
            lastname
          }
          registrations {
            id
            actionPosition {
              id
              name
            }
          }
          appointments(
            options: {
              startRow: 0
              endRow: 0
              sorting: [{ colId: "date", sort: "DESC" }]
              filters: [
                {
                  filterType: text
                  operator: AND
                  name: "type"
                  conditions: [{ type: equals, value: ["T1", "T2", "TI"] }]
                }
              ]
            }
          ) {
            id
            type
            status
            accessReason
            executionDate
          }
          type
          billingPartitions {
            name
          }
          CAN {
            one
            two
            three
            four
            five
          }
        }
      }
    }
  }
`
